// English strings (source language): progression.

const en = {
  title: 'Level and achievements',
  intro: 'Every ride earns XP. Levels unlock jerseys, frames and circuits, achievements reward your milestones.',
  levelCaps: 'LEVEL',
  nextLevel: (level: number, xp: string) => `level ${level} at ${xp} XP`,
  howTo: 'Earn XP by riding (km and minutes), finishing on the podium, hitting opponents, completing workouts and unlocking achievements. Titles:',
  levelReq: (n: number) => `Level ${n}`,
  unlocks: 'Unlocks',
  lvl: (n: number) => `Lvl ${n}`,
  achievements: 'Achievements',
  ftpHistory: 'FTP history',
  cols: { date: 'Date', before: 'Before', after: 'After', diff: 'Change' },
  ftpEmpty: 'Your FTP moves here as your rides change it. A hard effort, or the FTP test or Ramp test in Training, is the quickest way.',
};
export default en;
